import { flexBox } from 'common/styles/mixins'
import styled from 'styled-components'
import { Paper, Box } from '@mui/material'

export const MainContainer = styled.div`
  ${flexBox('flex', 'center', 'center', 'column', '1rem')}
  flex: 1;
  // width: 310px;
  padding: 20px;
  align-items: flex-start;
  justify-content: flex-start;
  position: relative;
  padding-top: 100px;
`

export const ContentContainer = styled.div`
  ${flexBox('flex', 'center', 'center', 'column', '1rem')}
  width: 100%;
  margin-top: 10px;
`

export const SwitchContainer = styled.div`
  ${flexBox('flex', 'unset', 'center', 'row', '0.5rem')}
  background-color: var(--secondary-lightest);
  border: 1px solid var(--grayscale-light);
  border-radius: 0.25rem;
  padding-left: 1em;
  margin-bottom: 10px;
  width: fit-content;
`

export const ModeToggleContainer = styled.div`
  ${flexBox('flex', 'center', 'center', 'row', '0.5rem')}
  background-color: var(--primary-lightest);
  border-radius: 8px;
  padding: 8px 12px;
  margin-bottom: 15px;
  width: fit-content;
  position: fixed;
  top: 60px;
  z-index: 10;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  align-self: center;
`

export const ToggleOption = styled.span<{ $isActive: boolean }>`
  font-weight: ${(props) => (props.$isActive ? 'bold' : 'normal')};
  color: ${(props) =>
    props.$isActive ? 'var(--primary)' : 'var(--grayscale-dark)'};
  cursor: pointer;
  padding: 4px 8px;
  transition: all 0.2s ease;
`

export const Info = styled.div`
  text-align: center;
`

export const QRCodeContainer = styled(Paper)`
  ${flexBox('flex', 'center', 'center', 'unset', 'unset')}
  height: 256px;
  aspect-ratio: 1;
  padding: 10px;
  background: white;
  border-radius: 12px;
  position: relative;
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.1);
`

export const ErrorMessage = styled.p`
  color: var(--error);
  text-align: center;
`

export const CompanySelectionContainer = styled.div`
  width: 100%;
  max-width: 400px;
  margin-bottom: 15px;
`

export const ValidityInfo = styled.div`
  padding: 12px 16px;
  background-color: var(--warning-lightest);
  border-left: 3px solid var(--warning);
  border-radius: 4px;
  width: 90%;
  max-width: 380px;
`

export const ValidationLabel = styled(Box)`
  position: absolute;
  bottom: 4px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  align-items: center;
  gap: 4px;
  background-color: rgba(255, 255, 255, 0.9);
  border-radius: 4px;
  padding: 2px 8px;
  width: 100%;
  justify-content: center;
`
